import * as React from 'react'

const SvgPDF = (props) => (
  <svg
    width={30}
    height={30}
    viewBox='0 0 30 30'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      opacity='0.35'
      d='M5 22.5V6.25C5 4.17875 6.67875 2.5 8.75 2.5H17.5L25 10V22.5C25 24.5712 23.3212 26.25 21.25 26.25H8.75C6.67875 26.25 5 24.5712 5 22.5Z'
      fill='#101AA1'
    />
    <path
      d='M17.5 7.5V2.5L25 10H20C18.6187 10 17.5 8.88125 17.5 7.5Z'
      fill='#101AA1'
    />
    <rect x='9' y='14' width='18' height='8' rx='1' fill='#101AA1' />
    <path
      d='M13.7031 19.0703H12.2891V18.0117H13.7031C13.8958 18.0117 14.0521 17.9792 14.1719 17.9141C14.2917 17.849 14.3789 17.7591 14.4336 17.6445C14.4909 17.5273 14.5195 17.3958 14.5195 17.25C14.5195 17.0938 14.4909 16.9492 14.4336 16.8164C14.3789 16.6836 14.2917 16.5768 14.1719 16.4961C14.0521 16.4128 13.8958 16.3711 13.7031 16.3711H12.8047V21H11.4336V15.3125H13.7031C14.1589 15.3125 14.5508 15.3958 14.8789 15.5625C15.2096 15.7292 15.4635 15.9583 15.6406 16.25C15.8177 16.5391 15.9062 16.8698 15.9062 17.2422C15.9062 17.6094 15.8177 17.9297 15.6406 18.2031C15.4635 18.4766 15.2096 18.6901 14.8789 18.8438C14.5508 18.9948 14.1589 19.0703 13.7031 19.0703ZM18.4922 21H17.2305L17.2383 19.9453H18.4922C18.7526 19.9453 18.9727 19.8828 19.1523 19.7578C19.3346 19.6328 19.4727 19.4466 19.5664 19.1992C19.6628 18.9492 19.7109 18.6419 19.7109 18.2773V18.0312C19.7109 17.7578 19.6836 17.5182 19.6289 17.3125C19.5768 17.1042 19.4987 16.931 19.3945 16.793C19.2904 16.6523 19.1602 16.5469 19.0039 16.4766C18.8503 16.4062 18.6732 16.3711 18.4727 16.3711H17.207V15.3125H18.4727C18.8581 15.3125 19.2109 15.3789 19.5312 15.5117C19.8542 15.6419 20.1328 15.8294 20.3672 16.0742C20.6042 16.3164 20.7865 16.6042 20.9141 16.9375C21.0443 17.2682 21.1094 17.6354 21.1094 18.0391V18.2773C21.1094 18.6784 21.0443 19.0456 20.9141 19.3789C20.7865 19.7122 20.6055 20 20.3711 20.2422C20.1367 20.4844 19.8594 20.6719 19.5391 20.8047C19.2214 20.9349 18.8724 21 18.4922 21ZM18.0156 15.3125V21H16.6445V15.3125H18.0156ZM23.1953 15.3125V21H21.8242V15.3125H23.1953ZM25.4062 17.6797V18.7344H22.8047V17.6797H25.4062ZM25.6289 15.3125V16.3711H22.8047V15.3125H25.6289Z'
      fill='white'
    />
  </svg>
)

export default SvgPDF
